import { useRecoilValue, useSetRecoilState } from 'recoil';
import Container from '../GlobalComponents/Container';
import Flex from '../GlobalComponents/Flex';
import { defined } from '../utils/defined';
import { CartSummary } from './components/CartSummary';
import { Error } from '../components/Error';
import { checkoutErrorsState, sendOrderErrorState } from '../Checkout/atoms';
import { SendOrderError } from '../Checkout/hooks/useSendOrder';

export const MobileCart: React.FC = () => {
	const checkoutErrors = useRecoilValue(checkoutErrorsState);
	const setSendOrderError = useSetRecoilState(sendOrderErrorState);
	return (
		<>
			{checkoutErrors.filter(defined).map(checkoutError => (
				<Error
					error={checkoutError.message}
					p={0}
					noBack
					onDismiss={() => {
						if (checkoutError instanceof SendOrderError) {
							setSendOrderError(undefined);
						}
					}}
				/>
			))}
			<Flex $justifyContent="center">
				<Container width={'1140'}>
					<CartSummary />
				</Container>
			</Flex>
		</>
	);
};
